export const SHOW_HIDE_RHSPANEL = 'SHOW_HIDE_RHSPANEL';
export const SHOW_RHS_PANEL_TOGGLER = 'SHOW_RHS_PANEL_TOGGLER';
export const SHOW_HIDE_LHS_PANEL = 'SHOW_HIDE_LHS_PANEL';
